import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ButtonsComponent } from '../../shared/buttons/buttons.component';
import { createResetPwdForm } from './reset-pwd.forms';
import {AuthService} from '../../core/services/auth/auth.service';
import {SwalService} from '../../core/services/alerts/swal.service';

@Component({
  selector: 'app-reset-pwd',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ButtonsComponent,
  ],
  templateUrl: './reset-pwd.component.html',
  styleUrls: ['./reset-pwd.component.scss'],
})
export class ResetPwdComponent {
  private fb = inject(FormBuilder);
   auth = inject(AuthService);
   router = inject(Router);
  private route = inject(ActivatedRoute);
  private swalService = inject(SwalService);
  loading = false;
  success = false;
  error = '';

  form: FormGroup<{ email: FormControl<string | null> }> = createResetPwdForm(this.fb);

  get f() {
    return this.form.controls;
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { email } = this.form.value;

    this.auth.forgotPassword({ email: email! }).subscribe({
      next: () => {
        this.swalService.notify(
          'Ti abbiamo inviato una mail per reimpostare la password.',
          'success'
        );
      },
      error: () => {
        this.swalService.apiError(
          'Errore durante l’invio della mail di recupero password.'
        );
      },
    });
  }
}
